import { useEvent, useStore, useStoreMap } from 'effector-react/compat'
import {
    $basket,
    $basketActualPositions,
    $deleteConfirmationGoodId,
    addGoodBasket,
    applyConfirmationDelete,
    cancelConfirmationDelete,
    changeBasketItemCount,
    clearBasketByOrderId,
    decrementBasketItemCount,
    deleteConfirmBasketItem,
    hiddenBasketItem,
    incrementBasketItemCount,
    visibleBasketItem
} from '@entities/basket/model'
import { sumBy } from 'lodash-es'

export const useAddGoodBasket = () => useEvent(addGoodBasket)
export const useClearBasketByOrderId = () => useEvent(clearBasketByOrderId)
export const useDecrementBasketItemCount = () => useEvent(decrementBasketItemCount)
export const useIncrementBasketItemCount = () => useEvent(incrementBasketItemCount)
export const useChangeBasketItemCount = () => useEvent(changeBasketItemCount)
export const useDeleteConfirmationGoodId = () => useStore($deleteConfirmationGoodId)
export const useApplyConfirmationDelete = () => useEvent(applyConfirmationDelete)
export const useCancelConfirmationDelete = () => useEvent(cancelConfirmationDelete)

export const useDeleteBasketItem = () => useEvent(deleteConfirmBasketItem)
export const useHiddenBasketItem = () => useEvent(hiddenBasketItem)
export const useVisibleBasketItem = () => useEvent(visibleBasketItem)

export const useBasketActualCount = () =>
    useStoreMap($basketActualPositions, (items) => sumBy(items, (item) => item.count))
export const useBasketCount = () => useStoreMap($basket, (items) => sumBy(items, (item) => item.count))
export const useCheckBasket = () => useStoreMap($basket, (items) => items?.length > 0)

export const useBasketSumStock = () =>
    useStoreMap($basketActualPositions, (items) => sumBy(items, (item) => item.stockPriceSum * item.count))

export const useBasketSumDelivery = () =>
    useStoreMap($basketActualPositions, (items) => sumBy(items, (item) => item.deliveryPriceSum * item.count))

export const useBasketSumMinPrice = () =>
    useStoreMap($basketActualPositions, (items) => sumBy(items, (item) => item.minPriceSum * item.count))

export const useBasketItemByWebId = (webId: number) =>
    useStoreMap({
        store: $basket,
        keys: [webId],
        fn: (items, [id]) => items?.find((x) => x.webData.webId == id) || null
    })
export const useBasketItemByGoodId = (webId: number) =>
    useStoreMap({
        store: $basket,
        keys: [webId],
        fn: (items, [id]) => items?.find((x) => x.webData.goodId == id) || null
    })

export const useBasketCheckItemsWithStockAvailableErecipe = () =>
    useStoreMap($basket, (items) => items.some((x) => x.isAvailablePickupByErecipe))
